import { withFeaturePermission } from "./PermissionHOC" 
import React from "react"
export const PETextArea = withFeaturePermission((props)=><textarea {...props}>{props.children}</textarea>)
export const PEButton = withFeaturePermission((props)=><button {...props}>{props.children}</button>)
export const PEInput = withFeaturePermission((props)=><input {...props} />)
export const PEOption = withFeaturePermission((props)=><option {...props}>{props.children}</option>)
export const PESelect = withFeaturePermission((props)=><select {...props}>{props.children}</select>)
export const PEDiv = withFeaturePermission((props)=><div {...props}>{props.children}</div>)
export const PESpan = withFeaturePermission((props)=><span {...props}>{props.children}</span>)
export const PEImg = withFeaturePermission((props)=><img {...props}>{props.children}</img>)
export const PETable = withFeaturePermission((props)=><table {...props}>{props.children}</table>)
export const PETr = withFeaturePermission((props)=><tr {...props}>{props.children}</tr>)
export const PETd = withFeaturePermission((props)=><td {...props}>{props.children}</td>)
export const PETbody = withFeaturePermission((props)=><tbody {...props}>{props.children}</tbody>)
export const PEThead = withFeaturePermission((props)=><thead {...props}>{props.children}</thead>)
export const PETh = withFeaturePermission((props)=><th {...props}>{props.children}</th>)
export const PEA = withFeaturePermission((props)=><a {...props}>{props.children}</a>)
export const PEUL = withFeaturePermission((props)=><ul {...props}>{props.children}</ul>)
export const PELI = withFeaturePermission((props)=><li {...props}>{props.children}</li>)

